// Appels HTTP typés vers /api/quotations/*.

import { api } from "./client";

export type QuotationStatus = "draft" | "sent" | "accepted" | "declined" | "cancelled" | "invoiced";

export interface QuotationLine {
  id: string;
  description: string;
  quantity: number;
  unit_price: number;
  vat_rate: number;
  unit: string | null;
  position: number;
  amount_ht: number;
  amount_ttc: number;
}

export interface QuotationLineCreate {
  description: string;
  quantity: number;
  unit_price: number;
  vat_rate: number;
  unit?: string | null;
  position: number;
}

export interface QuotationPublic {
  id: string;
  reference: string | null;
  client_id: string | null;
  client_name: string | null;
  intervenant_id: string | null;
  intervenant_name: string | null;
  project_id: string | null;
  issue_date: string | null;
  expiry_date: string | null;
  status: QuotationStatus;
  amount_ht: number | null;
  vat_amount: number | null;
  amount_ttc: number | null;
  currency: string;
  notes: string | null;
  payment_terms: string | null;
  invoice_id: string | null;
  amount_invoiced: string;
  amount_remaining: string;
  discount_type: string | null;
  discount_value: number | null;
  discount_amount_ht: number | null;
  lines: QuotationLine[];
  created_at: string;
  updated_at: string;
}

export interface QuotationCreate {
  client_id?: string | null;
  intervenant_id?: string | null;
  project_id?: string | null;
  issue_date?: string | null;
  expiry_date?: string | null;
  currency?: string;
  notes?: string | null;
  payment_terms?: string | null;
  discount_type?: string | null;
  discount_value?: number | null;
  lines: QuotationLineCreate[];
}

export interface QuotationUpdate extends Partial<QuotationCreate> {
  status?: QuotationStatus;
}

function buildQuery(params: Record<string, unknown>): string {
  const parts: string[] = [];
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null || value === "") continue;
    parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
  }
  return parts.length ? `?${parts.join("&")}` : "";
}

export const quotationsApi = {
  list: (params?: { status?: string; client_id?: string; limit?: number; offset?: number }) =>
    api.get<QuotationPublic[]>(`/api/quotations${buildQuery(params ?? {})}`),

  get: (id: string) => api.get<QuotationPublic>(`/api/quotations/${id}`),

  create: (data: QuotationCreate) =>
    api.post<QuotationPublic>("/api/quotations", data),

  update: (id: string, data: QuotationUpdate) =>
    api.patch<QuotationPublic>(`/api/quotations/${id}`, data),

  delete: (id: string) => api.delete<void>(`/api/quotations/${id}`),

  toInvoice: (id: string, payload?: Record<string, unknown>) =>
    api.post<QuotationPublic>(`/api/quotations/${id}/to-invoice`, payload ?? {}),

  send: (id: string) =>
    api.post<QuotationPublic>(`/api/quotations/${id}/send`),
  duplicate: (id: string) =>
    api.post<QuotationPublic>(`/api/quotations/${id}/duplicate`),
};
